/**
 * Utility functions for device detection
 */

/**
 * Detect if the current device is mobile
 * @returns {boolean} true if mobile device
 */
export const isMobileDevice = () => {
  // Check user agent for mobile indicators
  const userAgent = navigator.userAgent || navigator.vendor || '';

  // Check for mobile user agents
  const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;

  // Check for touch capability (additional mobile indicator)
  const hasTouchScreen = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  // Check screen size (mobile-like dimensions)
  const isSmallScreen = window.innerWidth <= 768;

  return mobileRegex.test(userAgent) || (hasTouchScreen && isSmallScreen);
};

/**
 * Detect if the current device is iOS
 * @returns {boolean} true if iOS device
 */
export const isIOSDevice = () => {
  const userAgent = navigator.userAgent || navigator.vendor || '';
  return /iPad|iPhone|iPod/.test(userAgent);
};

/**
 * Detect if the current device is Android
 * @returns {boolean} true if Android device
 */
export const isAndroidDevice = () => {
  const userAgent = navigator.userAgent || navigator.vendor || '';
  return /android/i.test(userAgent);
};
